import React, { useCallback, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { BorrowerLeadGenerationTool } from 'borrower-lead-generation-tool';
import './BorrowerLeadForm.css';

const FormModal = ({ show, buttonClicked, modalData, loCommonData }) => {
  // stores the input field reference in a way that allows us to conditionally render
  // content or scroll to the element on button click.
  const loId = loCommonData?.loID || "";
  const loEmail = loCommonData?.email || "";
  const [node, setNode] = useState(null);
  // watches for changes in the form.
  const formRef = useCallback((node) => {
    // node refers to the name input field in the BorrowerLeadGenerationTool
    setNode(node);
  }, []);
  useEffect(() => {
    const handleButtonClick = (e) => {
      if (e.target && e.target.classList.contains('btn-success')) {
        if (modalData !== 'requestCallback') {
          buttonClicked(); // Close the modal if modalData is not "requestCallback"
        }
      }
    };

    document.addEventListener('click', handleButtonClick);

    return () => {
      document.removeEventListener('click', handleButtonClick);
    };
  }, [buttonClicked, modalData]); // Add modalData to the dependency array

  return (
    <>
      <Modal size="lg" centered show={show} onHide={buttonClicked}>
        <Modal.Header closeButton>
          <Modal.Title>Please fill the information below to continue</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <BorrowerLeadGenerationTool
              showCustomizeLOApplyNowUrl
              statesDomain={process.env.REACT_APP_STATE_DOMAIN}
              loanOfficerEmail={loEmail}
              loanOfficerUid={loId}
              loID={loId}
              leadSource="INHNPORT-083"
              showTruApprovalButton={false}
              showModalBackBtn={false}
              ref={formRef}
              continueBtnRedirectUrl={modalData}
              mainBtnName ={modalData==="requestCallback" ? "Submit" : "Get Started"}
            />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FormModal;